import React from "react";
import Breadcrumb from "../../../component/breadcrumb/Breadcrumb";
import { useState } from "react";
import { triggerNotification } from "../../../component/message/Msg";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../../config";
import { useEffect } from "react";
import Spinner from "../../../component/loadingbar/Spinner";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const AddEmployee = () => {
  const { id } = useParams();
  const token = config.token;
  const navigate = useNavigate();
  const animatedComponents = makeAnimated();

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  //--------------------------------- manage state ---------------------------------
  const [courses, setCourses] = useState([]);
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [empTypes, setEmpTypes] = useState([]);
  const [parentEmps, setParentEmps] = useState([]);

  const [formData, setFormData] = useState({
    first_name: "",
    isExternal: false,
    last_name: "",
    email: "",
    mobile_no: "",
    address: "",
    emp_type: "",
    parent_emp: "",
    dob: "",
    hiredate: "",
    incentive: "",
    profile: "",
    courses: [],
  });

  const handleExternalBtn = () => {
    setFormData((prevData) => ({
      ...prevData,
      isExternal: !prevData.isExternal,
    }));
    setSelectedCourses([]);
  };
  const handleStateChange = async (e) => {
    // console.log(formData);
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]:
        e.target.name === "emp_type" ? String(e.target.value) : e.target.value,
    }));

    if (e.target.name === "profile") {
      setFile(e.target.files[0]);
    }

    if (e.target.name === "emp_type") {
      setFormData((prevData) => ({
        ...prevData,
        ["parent_emp"]: "",
        ["incentive"]: empTypes[e.target.selectedIndex - 1]?.incentive || "",
      }));
      fetch(`${config.host_url}sales/by-type/${e.target.value}`, {
        method: "GET",
        headers: {
          token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            // console.log("parent_emp: ", data.data);
            setParentEmps(data.data);
            // setFormData()
          } else if (data.status === 401) {
            // Invalid token
            console.error("Invalid token");
          } else {
            // Handle other errors
            console.error("Internal server error");
          }
        })
        .catch((error) => {
          console.error("Error fetching sales type:", error);
        });
    }
  };
  const handleCoursesChange = (selectedOptions) => {
    setSelectedCourses(selectedOptions);
    // console.log();
    setFormData((prevData) => ({
      ...prevData,
      courses: selectedOptions?.map((op) => op.id), //here in array add selectedOptions.id
    }));
  };

  //--------------------------------- get/read sales-type for dropdown ----------------------------------r
  useEffect(() => {
    //sales-type
    setLoading(true);
    fetch(`${config.host_url}sales-type`, {
      method: "GET",
      headers: {
        token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          // console.log(data.data);
          setEmpTypes(data.data);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching sales type:", error);
      })
      .finally(() => {
        setLoading(false);
      });

    // Fetch courses list
    fetch(`${config.host_url}course`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          console.log(data.data);
          const courseOptions = data.data?.map((course) => ({
            value: course.course_name,
            label: course.course_name,
            id: course.course_id,
          }));
          // setFormData((prevData) => ({
          //   ...prevData,
          //   courses: courseOptions?.map((op) => op.id),
          // }));
          setCourses(courseOptions);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching courses:", error);
      });
  }, [token]);

  // --------------------------------------- submit form -----------------------------------C--U
  const createEmployeeBtn = async (e) => {
    if (
      !formData.first_name?.trim() ||
      !formData.last_name?.trim() ||
      !formData.mobile_no?.trim() ||
      !formData.address?.trim() ||
      !formData.emp_type?.trim() ||
      !formData.parent_emp?.trim() ||
      !formData.dob?.trim() ||
      !formData.hiredate?.trim() ||
      !formData.incentive
    ) {
      triggerNotification("error", "Input fields cannot be empty!!");
      return; // Stop form submission
    } else if (selectedCourses.length <= 0) {
      triggerNotification("error", "Please add courses");
      return;
    }

    // --- Email validation ---
    const validateEmail = (email) => {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      return emailRegex.test(email);
    };
    if (!validateEmail(formData.email)) {
      triggerNotification("error", "Please enter a valid email address");
      return; // Stop form submission
    }

    selectedCourses?.map((course) => console.log(course.id));

    const formDataWithFile = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "profile") {
        formDataWithFile.append(key, file);
      } else if (key === "courses") {
        // formDataWithFile.append(
        //   key,
        //   selectedCourses?.map((op) => op.id)
        // );
        selectedCourses?.forEach((course) => {
          formDataWithFile.append("courses[]", course.id);
        });
      } else {
        formDataWithFile.append(key, formData[key]);
      }
    });

    console.log(formData);
    console.log(formDataWithFile);
    // Call the API to create a employee with formData
    try {
      if (!token) {
        triggerNotification("error", "Please login to create a employee");
        return;
      }
      // console.log(formData);

      await fetch(
        `${config.host_url}sales/${id ? decodeURIComponent(atob(id)) : ""}`,
        {
          method: id ? "PUT" : "POST",
          headers: {
            token: token,
          },

          body: formDataWithFile,
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            triggerNotification(
              "success",
              `employee ${id ? "updated" : "created"} successfully.`
            );
            setFormData({
              first_name: "",
              isExternal: false,
              last_name: "",
              email: "",
              mobile_no: "",
              address: "",
              emp_type: "",
              parent_emp: "",
              dob: "",
              hiredate: "",
              incentive: "",
              profile: "",
              courses: [],
            });
            setSelectedCourses([]);
            navigate("/viewemployees");
          } else if (data.status === 400) {
            triggerNotification("error", `Validation Error`);
          } else if (data.status === 401) {
            triggerNotification("error", "Unauthenticated user!");
          } else {
            triggerNotification("error", "Internal Server Error");
          }
        });
    } catch (error) {
      triggerNotification(
        "error",
        "Some Error Occurred!! Please try again later"
      );
    }
  };

  //-------------------------------------- clear form data --------------------------------------r
  const clearForm = () => {
    setFormData({
      first_name: "",
      isExternal: false,
      last_name: "",
      email: "",
      mobile_no: "",
      address: "",
      emp_type: "",
      parent_emp: "",
      dob: "",
      hiredate: "",
      incentive: "",
      profile: "",
      courses: [],
    });
    setSelectedCourses([]);

    if (id) {
      navigate("/viewemployees");
    }
  };

  //---------------------------------------------- get data for update / edit  employee  ----------------------------------------------------r

  useEffect(() => {
    if (id !== undefined) {
      setLoading(true);

      fetch(`${config.host_url}sales/${decodeURIComponent(atob(id))}`, {
        method: "GET",
        headers: {
          token,
        },
      })
        .then((response) => response.json())
        .then(async (data) => {
          console.log(
            "get data for up: ",
            data.data.courses.map((crs) => crs.course_id)
          );
          const responseData = data.data;
          const serverHiredate = await new Date(responseData.hiredate);
          const formattedHiredate = serverHiredate.toISOString().split("T")[0];
          const serverDob = await new Date(responseData.dob);
          const formattedDob = serverDob.toISOString().split("T")[0];

          await setFormData({
            first_name: responseData.first_name,
            last_name: responseData.last_name,
            email: responseData.email,
            mobile_no: responseData.mobile_no,
            address: responseData.address,
            emp_type: String(responseData.emp_type),
            dob: formattedDob,
            hiredate: formattedHiredate,
            incentive: responseData.incentive,
            profile: responseData.profile,
          });

          const selectedCoursesOptions = data.data.courses?.map((course) => ({
            value: course.course_name,
            label: course.course_name,
            id: course.course_id,
          }));
          setSelectedCourses(selectedCoursesOptions);

          setFormData((prevData) => ({
            ...prevData,
            courses: selectedCoursesOptions?.map((op) => op.id),
          }));
          //get emp name by type
          fetch(`${config.host_url}sales/by-type/${responseData.emp_type}`, {
            method: "GET",
            headers: {
              token,
            },
          })
            .then((response) => response.json())
            .then((data) => {
              if (data.status === 200) {
                // console.log("parent_emp: ", data.data);
                setParentEmps(data.data);
                setFormData((prevData) => ({
                  ...prevData,
                  parent_emp: String(responseData.parent_emp),
                }));
              } else if (data.status === 401) {
                // Invalid token
                console.error("Invalid token");
              } else {
                // Handle other errors
                console.error("Internal server error");
              }
            })
            .catch((error) => {
              console.error("Error fetching sales type:", error);
            });
        });

      setLoading(false);
    }
  }, [id]);

  return (
    <>
      <Breadcrumb txt="Manage Employee" subpath={["Add Employee"]} />
      {/* form view */}
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center ">
            <h5 className="mb-0">Add Employee</h5>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="card-body">
              <form>
                {/* first | last name */}
                <div className="row">
                  {/* First Name */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="first_name"
                        id="first_name"
                        placeholder="First Name"
                        value={formData.first_name}
                        onChange={handleStateChange}
                        autoComplete="off"
                      />
                      <label htmlFor="first_name"> First Name</label>
                    </div>
                  </div>

                  {/* Last Name */}
                  <div className="col-md-6">
                    <div className="form-floating  form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="last_name"
                        id="last_name"
                        placeholder="Last Name"
                        value={formData.last_name}
                        onChange={handleStateChange}
                        autoComplete="off"
                      />
                      <label htmlFor="last_name"> Last Name</label>
                    </div>
                  </div>
                </div>

                {/* email | mobile no. */}
                <div className="row">
                  {/* Email */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="email"
                        id="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleStateChange}
                        autoComplete="off"
                      />
                      <label htmlFor="email"> Email</label>
                    </div>
                  </div>

                  {/* Mobile No. */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="number"
                        className="form-control"
                        name="mobile_no"
                        id="mobile_no"
                        placeholder="Mobile No."
                        value={formData.mobile_no}
                        onChange={handleStateChange}
                        autoComplete="off"
                      />
                      <label htmlFor="mobile_no"> Mobile No.</label>
                    </div>
                  </div>
                </div>

                {/* Address */}
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    id="address"
                    placeholder="Address"
                    value={formData.address}
                    onChange={handleStateChange}
                    autoComplete="off"
                  />
                  <label htmlFor="address"> Address</label>
                </div>

                {/* Employee Type */}
                <div className="col-md-12 mt-2">
                  <div className="form-floating form-floating-outline mb-4">
                    <select
                      className="form-select mx-auto"
                      name="emp_type"
                      id="emp_type"
                      value={formData.emp_type}
                      onChange={handleStateChange}
                    >
                      <option
                        value=""
                        disabled
                        selected
                        className="text-center"
                      >
                        ---- Select Employee Type ----
                      </option>
                      {empTypes?.map((empType) => (
                        <option key={empType.tid} value={empType.tid}>
                          {empType.sales_emp_type}
                        </option>
                      ))}
                    </select>
                    <label htmlFor="emp_type">Employee Type</label>
                  </div>
                </div>

                {/* Parent Employee */}
                <div className="col-md-12 mt-2">
                  <div className="form-floating form-floating-outline mb-4">
                    <select
                      className="form-select mx-auto"
                      name="parent_emp"
                      id="parent_emp"
                      value={formData.parent_emp}
                      onChange={handleStateChange}
                    >
                      <option
                        value=""
                        disabled
                        selected
                        className="text-center"
                      >
                        {parentEmps.length > 0
                          ? "---- Select Parent Employee ----"
                          : "Parental employee not available!"}
                      </option>
                      {parentEmps?.map((parentEmp) => (
                        <option key={parentEmp.sid} value={parentEmp.sid}>
                          {parentEmp.first_name} {parentEmp.last_name}
                        </option>
                      ))}
                    </select>
                    <label htmlFor="parent_emp">Parent Employee</label>
                  </div>
                </div>

                {/* dob | hire date */}
                <div className="row">
                  {/* Date Of Birth */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="date"
                        className="form-control"
                        name="dob"
                        id="dob"
                        placeholder="Date Of Birth"
                        value={formData.dob}
                        onChange={handleStateChange}
                        autoComplete="off"
                      />
                      <label htmlFor="dob"> Date Of Birth</label>
                    </div>
                  </div>

                  {/* Hire Date */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="date"
                        className="form-control"
                        name="hiredate"
                        id="hiredate"
                        placeholder="Hire Date"
                        value={formData.hiredate}
                        onChange={handleStateChange}
                        autoComplete="off"
                      />
                      <label htmlFor="hiredate"> Hire Date</label>
                    </div>
                  </div>
                </div>

                {/* Incentive */}
                <div className="col-md-12 mt-2">
                  <div className="form-floating form-floating-outline mb-4">
                    <input
                      type="number"
                      className="form-control"
                      name="incentive"
                      id="incentive"
                      placeholder="Incentive"
                      value={formData.incentive}
                      onChange={handleStateChange}
                      autoComplete="off"
                    />
                    <label htmlFor="incentive"> Incentive</label>
                  </div>
                </div>

                {/* Profile Picture */}
                <div className="col-md-12 mt-2">
                  <div className="form-floating form-floating-outline mb-4">
                    <input
                      type="file"
                      className="form-control"
                      name="profile"
                      id="profile"
                      onChange={handleStateChange}
                    />
                    <label htmlFor="profile">Profile Picture</label>
                  </div>
                </div>

                {/* third party techer | incentive */}
                <div className="row">
                  {/* third party techer */}
                  <div className="col-sm-3 my-auto">
                    <div className="">
                      <div
                        className="mb-4  px-3 select-none"
                        onClick={handleExternalBtn}
                      >
                        {formData.isExternal ? (
                          <span className="mdi mdi-checkbox-marked-outline mr-3  "></span>
                        ) : (
                          <span className="mdi mdi-checkbox-blank-outline mr-3 "></span>
                        )}
                        <span>External Contractor</span>
                        <span
                          style={{
                            visibility: formData.isExternal
                              ? "hidden"
                              : "visible",
                          }}
                        >
                          ?
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* incentive */}
                  {formData.isExternal && (
                    // {/* Select */}
                    <div className="col-sm-9 ">
                      <div className="form-floating form-floating-outline mb-4 ">
                        <Select
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          isMulti
                          options={courses}
                          value={selectedCourses}
                          placeholder="Select Courses"
                          onChange={handleCoursesChange}
                        />
                      </div>
                    </div>
                  )}
                </div>

                {/* submit | cancel */}
                <div className="mt-3 flex justify-content-end">
                  <div className="">
                    {/* clear/ calcel */}
                    <button
                      type="button"
                      className="btn  btn-secondary"
                      onClick={clearForm}
                    >
                      Cancel
                    </button>
                    {/* submit */}
                    <button
                      type="button"
                      className="btn ml-2 btn-primary"
                      onClick={createEmployeeBtn}
                    >
                      {id ? "update" : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddEmployee;
